export default __webpack_public_path__ + "static/media/grey-activity.8ea5113e.svg";